import React from 'react';
import { useTranslation } from 'react-i18next';
import './OrderReceiptModal.css';

const OrderReceiptModal = ({ order, onClose }) => {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleString();
  };

  if (!order) return null;

  return (
    <div className="order-receipt-overlay" onClick={onClose} role="dialog" aria-label={t('orders.receipt') || 'Receipt'}>
      <div className="order-receipt-modal" onClick={e => e.stopPropagation()}>
        <div className="order-receipt-header">
          <h3>{t('orders.receipt') || 'Receipt'}</h3>
          <button type="button" className="order-receipt-close" onClick={onClose} aria-label={t('chatPicker.close') || 'Close'}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="order-receipt-body">
          <p className="order-receipt-restaurant">{order.restaurantName}</p>
          <p className="order-receipt-meta">{formatDate(order.createdAt)} · {t('orders.orderNumber') || 'Order #'}: {order.orderNumber}</p>

          <div className="order-receipt-items">
            {order.items?.map((item, index) => (
              <div key={index} className="order-receipt-item">
                <div className="order-receipt-item-main">
                  <span className="order-receipt-qty">{item.quantity}x</span>
                  <span className="order-receipt-name">{item.name}</span>
                  {item.variationOptionPrices && item.variationOptionPrices.length > 0 ? (
                    <div className="order-receipt-variations">
                      {item.variationOptionPrices.map((v, vIdx) => (
                        <div key={vIdx} className="order-receipt-var">
                          <span className="order-receipt-var-name">{v.variationName}:</span>
                          <span>{v.optionName}{v.price != null && v.price !== 0 ? ` (+€${Number(v.price).toFixed(2)})` : ''}</span>
                        </div>
                      ))}
                    </div>
                  ) : item.selectedVariations && (
                    <div className="order-receipt-variations">
                      {Array.isArray(item.selectedVariations)
                        ? item.selectedVariations.map((v, vIdx) => (
                            <div key={vIdx} className="order-receipt-var">
                              <span className="order-receipt-var-name">{v.name}:</span>
                              <span>{v.selectedOptions?.join(', ')}</span>
                            </div>
                          ))
                        : Object.entries(item.selectedVariations).map(([name, opts], vIdx) => (
                            <div key={vIdx} className="order-receipt-var">
                              <span className="order-receipt-var-name">{name}:</span>
                              <span>{Array.isArray(opts) ? opts.join(', ') : opts}</span>
                            </div>
                          ))}
                    </div>
                  )}
                  {item.selectedIngredients && item.selectedIngredients.length > 0 && (
                    <div className="order-receipt-ingredients">
                      {t('cart.ingredientsIncluded') || 'Ingredients'}: {item.selectedIngredients.join(', ')}
                    </div>
                  )}
                </div>
                <span className="order-receipt-price">€{(item.price * item.quantity).toFixed(2)}</span>
              </div>
            ))}
          </div>

          <div className="order-receipt-totals">
            {order.subtotalBeforeTax != null && (
              <div className="order-receipt-row">
                <span>{t('orders.subtotalBeforeTax') || 'Subtotal (before tax)'}:</span>
                <span>€{order.subtotalBeforeTax.toFixed(2)}</span>
              </div>
            )}
            {order.taxAmount != null && order.taxAmount > 0 && (
              <div className="order-receipt-row">
                <span>{t('orders.tax') || 'Tax'} {order.taxRate ? `(${order.taxRate}%)` : ''}:</span>
                <span>€{order.taxAmount.toFixed(2)}</span>
              </div>
            )}
            {order.deliveryFee > 0 && (
              <div className="order-receipt-row">
                <span>{t('orders.deliveryFee') || 'Delivery Fee'}:</span>
                <span>€{order.deliveryFee.toFixed(2)}</span>
              </div>
            )}
            {order.serviceFee != null && order.serviceFee > 0 && (
              <div className="order-receipt-row">
                <span>{t('orders.serviceFee') || 'Service Fee'}:</span>
                <span>€{order.serviceFee.toFixed(2)}</span>
              </div>
            )}
            <div className="order-receipt-row order-receipt-total">
              <span>{t('orders.total') || 'Total'}:</span>
              <span>€{((order.total || 0) + (order.walletAmount || 0)).toFixed(2)}</span>
            </div>
          </div>

          <div className="order-receipt-payment">
            <span>{t('orders.paymentMethod') || 'Payment Method'}:</span>
            <span>
              {order.paymentMethod === 'stripe' ? (t('orders.cardPayment') || 'Card') :
               order.paymentMethod === 'cash' ? (t('orders.cash') || 'Cash') :
               order.paymentMethod === 'wallet' ? (t('orders.wallet') || 'Wallet') :
               (t('orders.other') || order.paymentMethod)}
            </span>
          </div>

          <div className="order-receipt-rate-app">
            <p className="order-receipt-rate-app-title">{t('activeOrder.rateAppTitle') || 'Enjoying the app?'}</p>
            <p className="order-receipt-rate-app-text">{t('activeOrder.rateAppText') || 'Rate us on the App Store or Play Store — your feedback helps us improve.'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderReceiptModal;
